// @flow
import React from 'react';

import {
  withTypedRouter,
  type WithRouterProps,
} from 'app/general/withTypedRouter';

function isLeftClickEvent(event: {button?: number}): boolean {
  return event.button === 0;
}

type EventProp = {
  metaKey: boolean,
  altKey: boolean,
  ctrlKey: boolean,
  shiftKey: boolean,
};

function isModifiedEvent(event: EventProp): boolean {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

type OwnProps = {|
  to: string,
  activeTo: string,
  inactiveClassName: string,
  activeClassName: string,
  children: any,
  className: string,
  href?: string,
|};

type RouterProps = WithRouterProps<>;

type Props = {|
  ...OwnProps,
  ...RouterProps,
|};

class ToggleActiveLink extends React.PureComponent<Props> {
  static defaultProps = {
    inactiveClassName: '',
    activeClassName: '',
    className: '',
  };

  constructor(props: Props) {
    super(props);
  }

  handleClick = (event) => {
    const {to, activeTo, router} = this.props;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    event.preventDefault();
    router.push(this.resolveToLocation(router, to, activeTo));
  };

  resolveToLocation(router, to, activeTo) {
    return router.isActive(to) ? activeTo : to;
  }

  render() {
    const {to, activeTo, activeClassName, router, inactiveClassName} =
      this.props;
    let {href, className} = this.props;

    if (router) {
      href = this.resolveToLocation(router, to, activeTo);
      className = `${className} ${
        router.isActive(to) ? activeClassName : inactiveClassName
      }`;
    }

    return (
      <a className={className} href={href} onClick={this.handleClick}>
        {this.props.children}
      </a>
    );
  }
}

export default withTypedRouter<OwnProps, RouterProps>(ToggleActiveLink);
